import { Switch } from '@headlessui/react';

export function Toggle({
  value,
  onChange,
  label,
  className,
}: {
  value: boolean;
  onChange: (e) => void;
  label?: string;
  className?: string;
}) {
  return (
    <div className={className}>
      <Switch
        checked={value}
        onChange={onChange}
        className={`${value ? 'bg-brand' : 'bg-light'}
            relative inline-flex h-5 w-10 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
      >
        <span className="sr-only">{label}</span>
        <span
          aria-hidden="true"
          className={`${value ? 'translate-x-5' : 'translate-x-0'}
              pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
    </div>
  );
}
